export const en = {
    platform: 'Show',
    strategy: 'Strategy'
};
